// src/App.jsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/layout/Header';
import DynamicHero from './components/sections/hero/DynamicHero';
import About from './components/sections/about/About';
import FeaturedEvents from './components/sections/events/FeaturedEvents';
import InteractiveGlobe from './components/sections/globe/InteractiveGlobe';
import PurchasePage from './components/sections/trips/PurchasePage';
import ItineraryUploadSection from './components/sections/upload/ItineraryUploadSection';
import DonationSection from './components/sections/donation/DonationSection';
// import CustomTripSection from './components/sections/custom-trip/CustomTripSection'; // TOGGLED OFF FOR V2.0 LAUNCH
import AugmentedRealityPreview from './components/sections/ar-preview/AugmentedRealityPreview';
import Contact from './components/sections/contact/Contact';

// Feature flags for V2.0 launch
const FEATURE_FLAGS = {
  CUSTOM_TRIP_SECTION: false, // Toggle this to true when ready to re-enable
};

const App = () => (
  <Router>
    <div className="min-h-screen bg-gray-100">
      <Header />
      <main>
        <DynamicHero />
        <About />
        <FeaturedEvents />
        <InteractiveGlobe />
        <PurchasePage />
        <ItineraryUploadSection />
        <DonationSection />
        {/* Custom Trip Section - Toggled off for V2.0 launch */}
        {FEATURE_FLAGS.CUSTOM_TRIP_SECTION && <CustomTripSection />}
        <AugmentedRealityPreview />
        <Contact />
      </main>
      <footer className="bg-[#2F3437] text-white p-4 text-center">
        © {new Date().getFullYear()} TravelSquad LLC All rights reserved.
      </footer>
    </div>
  </Router>
);

export default App;